import React, { useState } from 'react';

const SectionIsAgeLimited = ({ circle, event, setEvent, isNew }) => {
  const [showPullDown, setShowPullDown] = useState(
    event.lower_age_limit || event.upper_age_limit ? true : false
  );

  const AgeSelect = (prop) => {
    const options = [];
    options.push(
      <option value="設定なし">
        {prop.name === 'lower_age_limit' ? '下限なし' : '上限なし'}
      </option>
    );
    for (let i = 14; i <= 80; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return (
      <select
        className="custom-select custom-select-sm"
        value={prop.value}
        onChange={(e) => prop.onChange(e.target.value)}
        disabled={!isNew}
      >
        {options}
      </select>
    );
  };

  return (
    <section id="gender_managed">
      <div className="container col-md-8 col-lg-6">
        <div style={{ display: 'flex' }}>
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
            募集年齢制限
          </p>
        </div>
        <p className="text-gray text-fz-small mt-0 mb-1">
          ※イベント初回作成時のみ設定できます。あとから変更できません。
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="showPullDown"
              defaultChecked={showPullDown}
              onChange={(e) => {
                setShowPullDown(e.target.checked);
                e.target.checked === false &&
                  setEvent((prev) => ({
                    ...prev,
                    lower_age_limit: null,
                    upper_age_limit: null,
                  }));
              }}
              disabled={!isNew}
            />
            <label className="custom-control-label" htmlFor="showPullDown">
              募集年齢を制限する
            </label>
          </div>
        </div>
        {showPullDown && (
          <div className="container col-md-8 col-lg-6 p-3_5">
            <div className="d-flex justify-content-between align-items-center">
              <AgeSelect
                name="lower_age_limit"
                value={event.lower_age_limit}
                onChange={(value) => {
                  const age = isNaN(+value) ? null : +value;
                  setEvent((prev) => ({ ...prev, lower_age_limit: age }));
                }}
              />
              <span className="mx-3">〜</span>
              <AgeSelect
                name="upper_age_limit"
                value={event.upper_age_limit}
                onChange={(value) => {
                  const age = isNaN(+value) ? null : +value;
                  setEvent((prev) => ({ ...prev, upper_age_limit: age }));
                }}
              />
              歳
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionIsAgeLimited;
